import { useState, useEffect } from "react";
import { IExpressValidatorError } from "interfaces/ExpressError";

import {
   createMaintenanceService,
   editMaintenanceService
} from "services/MaintenanceService";

import { StepModalTemplate } from "templates/StepModalTemplate";

import { transformValidatorError } from "utils/transformValidatorError";

import { Tab } from "../../../TabHeader";

import * as S from "./styles";
import { useMaintenanceRegister } from "contexts/register/Maintenance";
import { MaintenanceForm } from "components/Forms/Maintenance/MaintenanceForm";
import { IMaintenance } from "interfaces/Maintenance";

type Props = {
  opened: boolean;
  setOpened: (value: boolean) => void;
  data?: IMaintenance;
};

const tabs: Tab[] = [
  { index: 0, text: "Dados da solicitação" },
];

export function StepRegisterMaintenance({ opened, setOpened, data }: Props) {
  const {
    errors,
    maintenance,
    resetMaintenance,
    setMaintenance,
    searching,
    setErrors,
  } = useMaintenanceRegister();

  const [tab, setTab] = useState<Tab>(tabs[0]);
  const [invalidTabs, setInvalidTabs] = useState<Tab[]>([]);

  const [sending, setSending] = useState<boolean>(false);
  
  useEffect(()=>{
    if(Object.keys(errors).length<1){
      setInvalidTabs([])
    }
  },[errors])

  useEffect(() => {
    if (data) {
      setMaintenance(data)
      setInvalidTabs([]);
      setErrors({});

      return;
    }
    resetMaintenance();
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

  async function handleSubmit() {
    setSending(true);
    if (data) {
      return await editMaintenanceService({
        maintenance: {
          ...maintenance,
          id: data.id,
        }
      })
        .then((res) => {
          if (res.status === true) {
            localStorage.setItem(
              "message",
              "Os dados do Solicitação foram cadastrados corretamente."
            );
            window.location.reload();
          }
        })
        .catch((error) => {
          treatValidatorErrors(error.response.data.error);
        })
        .finally(() => {
          setSending(false);
        });
    }


      await createMaintenanceService({
        maintenance
      })
        .then((res) => {
          if (res.status === true) {
            localStorage.setItem(
              "message",
              "Os dados da solicitação foram cadastrados corretamente."
            );
            window.location.reload();
          }else{
            treatValidatorErrors(res.data.error);
          }
        })
        .catch((error) => {
          treatValidatorErrors(error.response.data.error);
        })
        .finally(() => {
          setSending(false);
        });
      setSending(false);
  }

  function setTabAsInvalid(tab: Tab) {
    setInvalidTabs((list) => [...list, tab]);
  }

  function treatValidatorErrors(validatorErrors: IExpressValidatorError) {
    setInvalidTabs([]);

    const { errors } =
      transformValidatorError(validatorErrors);
      setTabAsInvalid(tabs[0]);
    setErrors(errors);
  }

  function onTabClick(_tab: Tab) {
    setTab(_tab);
  }

  return (
    <StepModalTemplate
      deactivatedTabs={[]}
      title={`${data ? "Editar" : "Cadastrar"} Solicitação`}
      buttonText={`${data ? "Salvar" : "Efetuar cadastro"}`}
      opened={opened}
      setOpened={setOpened}
      disableButton={Object.keys(errors).length > 0}
      tabs={tabs}
      invalidTabs={invalidTabs}
      selectedTab={tab}
      sending={sending}
      setSelectedTab={onTabClick}
      handleSubmit={handleSubmit}
    >
      <S.Container>
        {searching && (
          <S.LoadingWrapper>
            <span>Buscando dados da Solicitação...</span>
          </S.LoadingWrapper>
        )}

        {!searching && (
          <div>
            {tab.index === 0 && <MaintenanceForm />}
          </div>
        )}
      </S.Container>
    </StepModalTemplate>
  );
}

